import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import I18n from '../../../config/i18n';
import { Row, Col } from '../../../utils/grid/Grid';
import HostTeaserBigList from '../../hostTeaser/HostTeaserBigList';

const TabNavigationContent = (props) => (
  <div className="tab-content-inner">
    <HostTeaserBigList hosts={props.hosts} />
    <Row className="tab-content-more">
      <Col xs={12} md={6} lg={4}>
        <Link className="tab-content-more-button" to={props.link}>
          {I18n.t('landing_page.more_objects')}
        </Link>
      </Col>
    </Row>
    <div className="tab-content-text">{props.text}</div>
  </div>
);

TabNavigationContent.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
  hosts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TabNavigationContent;
